import { SourcingAnalytics } from 'api-clients/monolith';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import CurrencyDollar from '@/assets/icons/currency-dollar-blue.svg';
import Identification from '@/assets/icons/identification-blue.svg';
import Users from '@/assets/icons/users.svg';

export function useMetricContent({
  metricKey,
}: {
  metricKey: keyof SourcingAnalytics;
}) {
  const intl = useIntl();

  return useMemo(() => {
    switch (metricKey) {
      case 'budget_spent':
        return {
          label: intl.formatMessage({ defaultMessage: 'Spend' }),
          icon: CurrencyDollar,
        };
      case 'hired_count':
        return {
          label: intl.formatMessage({ defaultMessage: 'Hired' }),
          icon: Identification,
        };
      case 'average_cph':
        return {
          label: intl.formatMessage({ defaultMessage: 'Avg CPH' }),
          icon: CurrencyDollar,
        };
      case 'applied_count':
        return {
          label: intl.formatMessage({ defaultMessage: 'Applied' }),
          icon: Users,
        };
      case 'average_cpa':
        return {
          label: intl.formatMessage({ defaultMessage: 'Avg CPA' }),
          icon: CurrencyDollar,
        };
      default:
        return {
          label: '',
          icon: '',
        };
    }
  }, [intl, metricKey]);
}
